module.exports = __webpack_public_path__ + "img/logo.8fd546b7.webp";